export default __webpack_public_path__ + "static/media/0xef938b6da8576a896f6e0321ef80996f4890f9c4.5f76076d.webp";